module.exports = __webpack_public_path__ + "h5/img/right-icon.b752aaa4.png";